export default __webpack_public_path__ + "static/media/billings-light-gnb.935336f2.svg";